import Vue from 'vue';
import cookie from 'vue-cookie';

/**
 * 是否存在cookie
 * @param  {String}  [key='_ibl'] [键]
 * @return {Boolean}              [description]
 */
function isSetCookie(key = '_ibl') {
    if (!cookie.get('_ibl') || (cookie.get('_ibl') === 'undefined')) {
        return false;
    }else{
        return true;
    }
}

function getUser(uid = 0){
    if(uid == 0){
        if (isSetCookie('_ibl')) {
            return Vue.http.post('user/judgeLogin')
        }else{
            return false;
        }
    }else{
        return '?';
    }
}

function inArray(search,array){
    for(var i in array){
        if(array[i]==search){
            return true;
        }
    }
    return false;
}

function getWechatConf(){
  Vue.http.post('index/weixinConfig',{
    url: location.href
  }).then(res => {
    //console.log(res)
    if(res.code){
      return res.message;
    }else{
      return res.data.value;
    }
  })
}


export default {
    isSetCookie: isSetCookie,
    getUser: getUser,
    inArray: inArray,
    getWechatConf: getWechatConf
}



// WEBPACK FOOTER //
// ./src/assets/scripts/func.js